<h1 mat-dialog-title>File Download</h1>
<div mat-dialog-content>Your file is downloading</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial>Ok</button>
</div>
